import React from "react";
import { constructPath, findRoute } from "routes";
import { RouteType } from "routes/types";
import { H2 } from "@blueprintjs/core";
import { useSelector } from "react-redux";
import { Tree } from "utils/tree";
import ProductionCard from "./ProductionCard";
import { selectServices } from "controllers/services/action";
import "./ProductionCanvas.scss";
import { IUser } from "controllers/users/action";
import { ITemplate } from "components/Template/types";

export interface CanvasProps {
  user: IUser | undefined;
  routes: Tree<RouteType>;
}

export default function ProductionCanvas(props: CanvasProps) {
  const { routes, user } = props;

  const services = useSelector(selectServices);

  const renderCard = (service: ITemplate) => {
    return (
      <ProductionCard
        key={service.name}
        name={service.name}
        label={service.label}
        title={service.description}
        brief={service.brief}
        keywords={service.keywords}
        link={user ? constructPath(findRoute(routes, "Model")) : `Applications/${service.name}`}
        buttonText={user ? "CREATE NEW MODEL" : "Learn More"}
      />
    );
  };
  return (
    <div className="production-canvas">
      <H2>Applications</H2>
      <div className="production-canvas__cards">
        <React.Fragment>
          {services?.map(service => renderCard(service))}
        </React.Fragment>
      </div>
    </div>
  );
}
